<div class="dialog-container">
    <span class="title">T&C</span>
    <button (click)="close()" mat-icon-button class="close-icon">
        <mat-icon aria-hidden="true">close</mat-icon>
    </button>
    @if (data.brandNameStrip; as brand_name) {
        <div class="desc" style="margin-bottom: 20px">The freebie offer is not valid for {{ brand_name }}.</div>
    }
    @if (data.productLabels.length) {
        <div class="desc">
            For {{ data.existingBrandName }}, freebies are not applicable on the following items since another offer is already
            applied on these:
        </div>
        <div class="scroll">
            <ul>
                @for (label of data.productLabels; track label) {
                    <li>
                        <span>{{ label }}</span>
                    </li>
                }
            </ul>
        </div>
    }
</div>
